import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent, MatDialogModule,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilsProvider } from "../../../../common/providers/utils-provider.service";
import { TranslateModule } from "@ngx-translate/core";
import { MatRadioButton, MatRadioGroup, MatRadioModule } from "@angular/material/radio";
import { MatLine } from "@angular/material/core";
import { MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { NgForOf, NgIf } from "@angular/common";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'borg-scale-form',
  standalone: true,
  templateUrl: './borg-scale-form.component.html',
  styleUrls: ['./borg-scale-form.scss'],
  imports: [
    ReactiveFormsModule,
    MatDialogContent,
    TranslateModule,
    MatRadioModule,
    MatDialogTitle,
    MatLine,
    MatFormFieldModule,
    NgForOf,
    NgIf,
    MatInput,
    MatDialogModule,
    MatButton
  ]
})
export class BorgScaleFormComponent implements OnInit, OnDestroy {

    public form: FormGroup;
    public optionFormControl = new FormControl('timeslot');

    public unit = "";
    private unitSub: Subscription = new Subscription();

    private _scaleMale: FormArray<FormControl>;
    private _scaleFemale: FormArray<FormControl>;

    public get scaleMale() : FormArray<FormControl> {
        return this._scaleMale;
    }
    public get scaleFemale() : FormArray<FormControl> {
        return this._scaleFemale;
    }

    constructor(
        public dialogRef: MatDialogRef<BorgScaleFormComponent>,
        private fb: FormBuilder,
        private toaster: MatSnackBar,
        private utils: UtilsProvider,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this._scaleMale = this.fb.array([]);
        this._scaleFemale = this.fb.array([]);
        this.form = this.fb.group({
          scaleMale: this._scaleMale,
          scaleFemale: this._scaleFemale,
          invertedScale: new FormControl(false),
        });
        for(let n = 0; n < 10; n++){
            this.scaleMale.push(this.createBound());
            this.scaleFemale.push(this.createBound());
        }
        if (this.data.data) {
            this.form.controls['invertedScale'].setValue(this.data.data.invertedScale ? true: false);
            this.scaleMale.patchValue(this.data.data.scaleMale);
            this.scaleFemale.patchValue(this.data.data.scaleFemale);
        }
    }

    public ngOnInit(): void {
        this.unitSub = this.data.unit$.subscribe((unit:any) => {
            this.unit = unit?.name;
        });
    }

    public ngOnDestroy(): void {
        this.unitSub.unsubscribe();
    }

    public onInvertedScaleChanged() {}

    public createBound() {
        return new FormControl('', [Validators.required])
    }

    public submitForm() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        this.dialogRef.close({
            edited: true,
            data: this.form.value,
        });
    }

    public onRemoveClicked() {
        this.dialogRef.close({
            edited: true,
        });
    }

  protected readonly FormControl = FormControl;
}
